import differenceInWeeks from 'date-fns/differenceInWeeks'
import isSameWeek from 'date-fns/isSameWeek'

import { parseDate } from './dateTimeHelper'

export const candidateFirstWeekInBatch = transitionedAt => {
  return isSameWeek(parseDate(transitionedAt), new Date(), { weekStartsOn: 1 })
}

export const candidateLastWeekInBatch = transitionedAt => {
  return differenceInWeeks(new Date(), parseDate(transitionedAt)) === 3
}
